/** The Anlagenverzeichnis: fixed assets and their AfA (lib/at/afa.ts), posted by the ledger. */
import type { AssetInput } from "@/lib/at/afa";
import type { AssetsResponse } from "@/lib/platform/pb-types";
import { pb } from "@/lib/platform/pocketbase";

export type Asset = AssetsResponse;

export type AssetFields = {
  name: string;
  type: Asset["type"];
  inServiceDate: string;
  cost: number;
  usefulLifeYears: number;
  method: Asset["method"];
  degressiveRate: number;
  privateUsePercent: number;
  disposalDate: string;
  account: string;
  document: string;
  notes: string;
};

export async function listAssets(workspaceId: string): Promise<Asset[]> {
  return pb.collection("assets").getFullList<Asset>({
    filter: pb.filter("workspace = {:workspaceId}", { workspaceId }),
    sort: "inServiceDate,name",
  });
}

export async function createAsset(workspaceId: string, fields: AssetFields): Promise<Asset> {
  return pb.collection("assets").create<Asset>({ ...fields, workspace: workspaceId });
}

export async function updateAsset(id: string, fields: Partial<AssetFields>): Promise<Asset> {
  return pb.collection("assets").update<Asset>(id, fields);
}

/** The ledger reverses its AfA; nothing is lost from the journal. */
export async function deleteAsset(id: string): Promise<void> {
  await pb.collection("assets").delete(id);
}

/** A stored asset as the AfA rules read it. */
export function afaInput(asset: Pick<Asset, keyof AssetInput>): AssetInput {
  return {
    type: asset.type,
    inServiceDate: (asset.inServiceDate ?? "").slice(0, 10),
    cost: asset.cost,
    usefulLifeYears: asset.usefulLifeYears ?? 0,
    method: asset.method,
    degressiveRate: asset.degressiveRate,
    privateUsePercent: asset.privateUsePercent,
    disposalDate: (asset.disposalDate ?? "").slice(0, 10) || undefined,
  };
}
